var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box box-static-study"},[_c('static-study-file',{staticStyle:{"height":"100%"},attrs:{"label":"Livrable de l'étude","parent_data":_vm.active_study,"file_property":"pdfLien"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }